import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';

/**
 * CNN LIVE LEGEND - SLIM CONTINUOUS GRADIENT (HORIZONTAL)
 * Estilo premium: Título con icono a la izquierda, todo centrado arriba de la barra.
 */

const GRADIENT_HORIZONTAL = "linear-gradient(90deg, rgb(255, 255, 4) 0%, rgb(255, 138, 4) 50%, rgba(229,49,45,1) 100%)";

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center", // <-- CAMBIO CLAVE: Centra todo el bloque horizontalmente
  pointerEvents: "none",
  gap: "8px",
}));

const Title = styled(Box)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 900,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: '#1a237e',
  textShadow: '0 1px 2px rgba(255,255,255,0.8)',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center', // <-- Aseguramos que el contenido interno también se centre
  gap: '6px',
  whiteSpace: 'nowrap',
  // Se eliminó el marginLeft: '4px' para que el centrado sea exacto
}));

const LegendWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '250px',
}));

const LegendBar = styled(Box)(({ theme }) => ({
  width: "250px",
  height: "18px",
  background: GRADIENT_HORIZONTAL,
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  border: "1px solid rgba(255,255,255,0.8)",
}));

const LabelsRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  paddingTop: '6px',
}));

const Label = styled(Box)(({ theme }) => ({
  color: "#333",
  fontWeight: 800,
  fontSize: "0.7rem",
  textTransform: "uppercase",
  textShadow: "0 0 3px rgba(255,255,255,1)",
  whiteSpace: 'nowrap',
}));

function RiskSelectorCNN_WMS_HEATMAP_Horizontal() {
  return (
    <Container>
      {/* 1. Bloque de título centrado arriba */}
      <Title>
        <ThunderstormIcon sx={{ fontSize: 18 }} />
        Convective Risk
      </Title>

      {/* 2. Cuerpo de la leyenda centrado debajo */}
      <LegendWrapper>
        {/* Barra de colores horizontal */}
        <LegendBar />

        {/* Fila de textos debajo de la barra */}
        <LabelsRow>
          <Label>Low</Label>
          <Label>Medium</Label>
          <Label>High</Label>
        </LabelsRow>
      </LegendWrapper>
    </Container>
  );
}

// memo: no depende de la hora; sin él se repintaba en cada paso del slider
export default React.memo(RiskSelectorCNN_WMS_HEATMAP_Horizontal);
